import { createContext } from "react";

const AccordionContext = createContext<{ id: string | number; itemId: number }>(
  { id: "", itemId: 0 }
);
const AccordionProvider = AccordionContext.Provider;
const AccordionConsumer = AccordionContext.Consumer;

export { AccordionProvider, AccordionConsumer, AccordionContext };
